import styled from 'styled-components';

export const SvgStyled = styled.svg`
    display: inline-block;
    vertical-align: middle;
    fill: transparent;
    stroke: ${({ theme }) => theme.colors.text.head};
`;
